import dayjs from "dayjs";
import { Field, Form, Formik } from "formik"; // Importing Formik components for form handling
import { observer } from "mobx-react"; // Importing observer for MobX state management
import moment from "moment";
import { Button, Modal } from "react-bootstrap"; // Importing Bootstrap components for UI
import { FormattedMessage } from "react-intl"; // Importing FormattedMessage for internationalization
import { getNextRoundedTime } from "../../../../constants/constants";
import { useStore } from "../../../../contexts/store-provider";
import LoaderButton from "../../../../shared-components/button/loader-button"; // Custom loader button component
import FormikDateFieldMUI from "../../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import FormikFormTimePicker from "../../../../shared-components/FormikFormHandlers/FormikFormTimePicker";
import { RebookReservationValidationSchema } from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema"; // Validation schema for the form
import FormLoader from "../../../../shared-components/FormLoader/FormLoader"; // Loader component for forms
import Label from "../../../../shared-components/label/label"; // Custom label component
import DeletePopupHOC from "../../../../shared-components/popup/delete/delete-popup-hoc"; // Higher-order component for delete popup

interface IProps {
  id: number; // ID of the break
  isLoading: boolean; // Loading state
  day: any;
  submitHandler: (data: any) => void; // Submit handler function
  onModalClosed: () => void; // Function to handle modal close
  initialValues: any; // Initial values for the form
  viewOnly: boolean; // Flag for view-only mode
}

const RebookReservationComponentForm = (props: IProps) => {
  const { masterManagementStore } = useStore(); // Accessing store context
  const { getClosedDays, getReservationSettingDetail } = masterManagementStore; // Getting staff list from store
  return (
    <>
      <Formik
        initialValues={{ ...props.initialValues, Time: getNextRoundedTime(5) }} // Initial values for the form
        enableReinitialize // Reinitialize form on prop changes
        // validateOnBlur={false} // Disable validation on blur
        validationSchema={RebookReservationValidationSchema(
          getReservationSettingDetail
        )} // Validation schema for the form
        onSubmit={async (values) => {
          props.submitHandler(values); // Submit handler for the form
        }}
      >
        {({ setFieldValue, values }) => (
          <Form className="user-form">
            {props.isLoading && <FormLoader loading={props.isLoading} />}{" "}
            {/* Loader for the form */}
            <Modal.Body>
              <div className="row">
                <div className="col-sm-12 form-group">
                  <Label
                    className="label-style"
                    required={true} // Mark label as required
                    label="date" // Label for title field
                  />
                  <Field
                    name="Date" // Name for title field
                    className="form-control"
                    disablePastDate={true} // Disable future dates
                    disabled={props.viewOnly}
                    isWeekdayScheduleCheck={true} // Check for weekday schedule
                    getClosedDays={getClosedDays} // Get closed days from store
                    reservationSettingDetail={getReservationSettingDetail}
                    as={FormikDateFieldMUI} // Custom Formik input component
                  />
                </div>
                <div className="col-sm-12 form-group">
                  <Label
                    className="label-style"
                    required={true} // Mark label as required
                    label="booking_time" // Label for start time field
                  />
                  <Field
                    name="Time" // Name for start time field
                    as={FormikFormTimePicker} // Custom Formik time picker component
                    shouldCheckPast={
                      moment(values.Date).format("YYYY-MM-DD") ==
                      moment().format("YYYY-MM-DD")
                        ? true
                        : false
                    } // Check if the time is in the past
                    min={dayjs()} // Minimum time value
                    interval={5}
                    className="form-control"
                    disabled={false} // Disable start time field
                  />
                </div>
              </div>
            </Modal.Body>
            {/* Footer Buttons */}
            <Modal.Footer className="justify-content-center gap-2">
              <Button
                variant="outline-danger"
                type="button"
                onClick={props.onModalClosed} // Close modal handler
                disabled={props.isLoading} // Disable button if loading
              >
                <i className="bi bi-x-lg me-1"></i>
                <FormattedMessage id="close" /> {/* Close button label */}
              </Button>
              {!props.viewOnly && (
                <>
                  <LoaderButton
                    type="submit"
                    iconName="bi-check-lg" // Icon for submit button
                    isLoading={props.isLoading} // Loading state for submit button
                    text={props.id > 0 ? "button_update" : "add"} // Text for submit button
                  />
                </>
              )}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DeletePopupHOC(observer(RebookReservationComponentForm)); // Exporting component wrapped with HOC and observer
